/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// 谁最懂我相关

// 列表
export function adSiteList(query) {
    return axios({
        url: "/admin/check/newindex",
        method: "get",
        params: query
    });
}

// 广告列表
export function adSiteAdList(query) {
    return axios({
        url: "/admin/ad_site/adList",
        method: "get",
        params: query
    });
}

export function parse(query) {
    return axios({
        url: "/admin/check/parse",
        method: "get",
        params: query
    });
}

export function downloadphp(query) {
    return axios({
        url: "/admin/check/downloadphp",
        method: "get",
        params: query
    });
}
export function newdownloadphp(query) {
    return axios({
        url: "/admin/check/newdownloadphp",
        method: "get",
        params: query
    });
}


export function parseimg(query) {
    return axios({
        url: "/admin/check/parseimg",
        method: "get",
        params: query
    });
}
export function creat4(query) {
    return axios({
        url: "/admin/check/creat",
        method: "get",
        params: query
    });
}

export function addbai(query) {
    return axios({
        url: "/admin/check/addbai",
        method: "get",
        params: query
    });
}

export function addhei(query) {
    return axios({
        url: "/admin/check/addhei",
        method: "get",
        params: query
    });
}

export function getlist(query) {
    return axios({
        url: "/admin/check/getlistcheck11",
        method: "get",
        params: query
    });
}
export function deletead(query) {
    return axios({
        url: "/admin/check/deletead",
        method: "get",
        params: query
    });
}

export function listbai(query) {
    return axios({
        url: "/admin/check/listbai",
        method: "get",
        params: query
    });
}

export function listhei(query) {
    return axios({
        url: "/admin/check/listhei",
        method: "get",
        params: query
    });
}

export function fileQual(query) {
    return axios({
        url: "/admin/check/fileQual",
        method: "get",
        params: query
    });
}
export function getCurl(query) {
    return axios({
        url: "/admin/check/getCurl",
        method: "get",
        params: query
    });
}

export function creatjs(query) {
    return axios({
        url: "/admin/check/creatjs",
        method: "get",
        params: query
    });
}
export function deletetem(query) {
    return axios({
        url: "/admin/check/deletetem",
        method: "get",
        params: query
    });
}

export function list(query) {
    return axios({
        url: "/admin/check/getlist",
        method: "get",
        params: query
    });
}

export function getlistlp(query) {
    return axios({
        url: "/admin/check/getlistlp",
        method: "get",
        params: query
    });
}

export function addlist(query) {
    return axios({
        url: "/admin/check/addlist",
        method: "get",
        params: query
    });
}

// 保存
// export function adSiteSave(data, formName, method = "post") {
//     var url =
//         formName === "add" ? "/admin/ad_site/save" : "/admin/ad_site/edit";
//     return axios({
//         url: url,
//         method: method,
//         data: data
//     });
// }


export function editsave(data, method = "post") {
    var url ="/admin/check/edit";
    return axios({
        url: url,
        method: method,
        data: data
    });
}
export function adSiteSave(data, method = "post") {
    var url =`/admin/check/save`
    return axios({
        url: url,
        method: method,
        data: data
    });
}


// 删除
export function adSiteDelete(data) {
    return axios({
        url: "/admin/check/delete",
        method: "post",
        data: data
    });
}

export function geteasy() {
    return axios({
        url: "/admin/check/geteasy",
        method: "get",
    });
}

// 删除
export function adSiteDeletemap(data) {
    return axios({
        url: `/admin/check/adSiteDeletemap/`,
        method: "get",
        params: data
    });
}
